<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { localizeActivityMessage } from 'dashboard/helper/localizeActivityMessage';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt, contentAttributes } = useMessageContext();
const { locale, t } = useI18n();
const localizedContent = computed(() =>
  localizeActivityMessage(
    content.value,
    locale.value,
    t,
    contentAttributes.value?.activity
  )
);

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span :title="localizedContent">{{ localizedContent }}</span>
  </BaseBubble>
</template>
